import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;


  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const rrhh = localStorage.getItem("adminrrhh");

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}



export default function TabSolicitudes({ value, setValue }) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

   


  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Tab para elegir el filtrado de la tabla"
          centered
        >
          {/* <Tab label="Desactivadas" {...a11yProps(0)} />
          <Tab label="Pendientes" {...a11yProps(1)} />
          <Tab label="Aprobadas" {...a11yProps(2)} />
          <Tab label="Sin autorizar" {...a11yProps(3)} /> */}
          {/* <Tab label="'DOC PENDIENTE" {...a11yProps(4)} /> orden tabs anterior  */}

         {/*   recordatorio <Tab label="Ver solicitudes ocultas" {...a11yProps(5)} />  
            solo si sos de rrhhadmin y tenes el permiso en el localstorague campo solicitud_oculta en 1 puede ver en el tab   
            
            */}

          <Tab label="Desactivadas" {...a11yProps(0)} />
          <Tab label="Pendientes" {...a11yProps(1)} />
           <Tab label="PRESELECCIÓN" {...a11yProps(2)} /> 
          <Tab label="Aprobadas" {...a11yProps(3)} />
          <Tab label="Sin autorizar" {...a11yProps(4)} />
       
          <Tab label="Ver solicitudes ocultas" {...a11yProps(5)} /> 
      
          
        </Tabs>
      </Box>
    </Box>
  );
}
